import React from "react";
import { useEffect, useState } from 'react';
import { Form, Button, Table, Col, Row } from 'react-bootstrap';
import { capitalizeFirstLetter } from '../Shared/Helpers';
import { v4 as uuidv4 } from 'uuid';
import { isEmpty } from "lodash";
import SweetAlert from "react-bootstrap-sweetalert";


const StepThree = ({ handleNext, handleBack, storedData }) => {

    const [educationRecords, setEducationRecords] = useState([]);
    const [errors, setErrors] = useState({});

    const spanStyle = {
        borderRadius: '5px',
        backgroundColor: '#f2f2f2',
        cursor: 'pointer',
        marginRight: '8px'
    };

    const handleCapitalWord = (index, field, value) => {
        updateEducationRecord(index, field, capitalizeFirstLetter(value));
    };

    const addEducationRecord = () => {
        const newRecord = {
            schoolOrOther: '',
            courseStudied: '',
            gradeOrResult: ''
        };
        setEducationRecords([...educationRecords, newRecord]);
    };

    const updateEducationRecord = (index, field, value) => {
        const updatedRecord = {
            ...educationRecords[index],
            [field]: value
        };
        const updatedRecords = [...educationRecords];
        updatedRecords[index] = updatedRecord;
        setEducationRecords(updatedRecords);
    };

    const removeEducationRecord = (index) => {
        const updatedRecords = [...educationRecords];
        updatedRecords.splice(index, 1);
        setEducationRecords(updatedRecords);
    };

    function getEducationRecordErrors() {
        const errors = {};
        educationRecords.forEach((record, index) => {
            if (isEmpty(record.schoolOrOther)) {
                errors[`schoolOrOther${index}`] = 'School or other is required';
            }
            if (isEmpty(record.courseStudied)) {
                errors[`courseStudied${index}`] = 'Course studied is required';
            }
            if (isEmpty(record.gradeOrResult)) {
                errors[`gradeOrResult${index}`] = 'Grade or result is required';
            }
        });
        return errors;
    }

    const handleNextCommand = () => {
        try {
            const logErrors = getEducationRecordErrors();

            // checking the error log before moving on
            if (!Object.values(logErrors).some(Boolean)) {
                setErrors([]);
                handleNext(educationRecords);
            } else {
                setErrors(logErrors);
            }

        } catch (e) {
            console.log(e);
        }
    };

    // ## HOOKS ##
    useEffect(() => {
        if (!isEmpty(storedData)) {
            setEducationRecords(storedData);
        } else {
            console.log("storedData is empty");

            const initialRecord = {
                schoolOrOther: '',
                courseStudied: '',
                gradeOrResult: ''
            };
            setEducationRecords([initialRecord]);
        }
    }, []);


    return (
        <Row>
            <div>
                <Col sm={12} md={12}>
                    <h2 >3. Education</h2>
                    <p>Start with your most recent and work back.</p>
                </Col>


                <Table striped bordered>
                    <thead>
                        <tr>
                            <th>School / College / University</th>
                            <th>Course Studied</th>
                            <th>Grade</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {educationRecords.map((record, index) => (
                            <tr key={index}>
                                <td data-label="School / College / University">
                                    <Form.Control
                                        className={errors[`schoolOrOther${index}`] ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                        type="text"
                                        maxLength="200"
                                        onBlur={(e) => handleCapitalWord(index, "schoolOrOther", e.target.value)}
                                        value={record.schoolOrOther}
                                        onChange={(e) => {
                                            updateEducationRecord(index, 'schoolOrOther', e.target.value);
                                            if (errors[`schoolOrOther${index}`]) {
                                                setErrors({ ...errors, [`schoolOrOther${index}`]: "" });
                                            }
                                        }}

                                    />
                                    {errors[`schoolOrOther${index}`] && <Form.Text className="text-danger"> <span className="star">*</span> {errors[`schoolOrOther${index}`]} </Form.Text>}
                                </td>
                                <td data-label="Course Studied">
                                    <Form.Control
                                        className={errors[`courseStudied${index}`] ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                        type="text"
                                        maxLength="200"
                                        onBlur={(e) => handleCapitalWord(index, "courseStudied", e.target.value)}
                                        value={record.courseStudied}
                                        onChange={(e) => {
                                            updateEducationRecord(index, 'courseStudied', e.target.value);
                                            if (errors[`courseStudied${index}`]) {
                                                setErrors({ ...errors, [`courseStudied${index}`]: "" });
                                            }
                                        }}
                                    />
                                    {errors[`courseStudied${index}`] && <Form.Text className="text-danger"> <span className="star">*</span> {errors[`courseStudied${index}`]} </Form.Text>}
                                </td>
                                <td data-label="Grade">
                                    <Form.Control
                                        className={errors[`gradeOrResult${index}`] ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                        type="text"
                                        maxLength="200"
                                        onBlur={(e) => handleCapitalWord(index, "gradeOrResult", e.target.value)}
                                        value={record.gradeOrResult}
                                        onChange={(e) => {
                                            updateEducationRecord(index, 'gradeOrResult', e.target.value);
                                            if (errors[`gradeOrResult${index}`]) {
                                                setErrors({ ...errors, [`gradeOrResult${index}`]: "" });
                                            }
                                        }}
                                    />
                                    {errors[`gradeOrResult${index}`] && <Form.Text className="text-danger"> <span className="star">*</span> {errors[`gradeOrResult${index}`]} </Form.Text>}
                                </td>
                                <td>
                                    {index > 0 && (
                                        <Button variant="warning" onClick={() => removeEducationRecord(index)}>Remove</Button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr style={{ backgroundColor: 'rgba(129, 105, 74, 0.1)' }}>
                            <td colSpan="4" style={{ textAlign: 'right' }}>
                                <span style={spanStyle} onClick={addEducationRecord} >
                                    <i className="fa fa-plus"></i>{' '}
                                    Add New Record
                                </span>
                            </td>
                        </tr>
                    </tfoot>
                </Table>


            </div>
            <Row>
                <Col sm={12} className="d-flex justify-content-between mt-3">
                    <Button className="btn-lg btn-shadow" variamt="danger" onClick={handleBack} >Back</Button>
                    <Button className="btn-lg btn-shadow" variamt="success" onClick={handleNextCommand}>Next</Button>
                </Col>
            </Row>

        </Row >
    );
}

export default StepThree;
